module.exports = __webpack_public_path__ + "static/media/01.23a64fae.mp3";